import { FeatureFlags } from '@/core/domain/configurations/models/configurations.model';
import { GetConfigParamsUseCase } from '@/core/domain/configurations/usecases/getConfigParams-loader.usecase';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    public featuresFlags = new BehaviorSubject<FeatureFlags | null>(null);

    constructor(
        private readonly getFeatureFlags: GetConfigParamsUseCase<FeatureFlags>,
    ) {}

    public reloadFeatureFlags(): void {
        this.requestFeatureFlags().subscribe((item) =>
            this.featuresFlags.next(item),
        );
    }

    public requestFeatureFlags(): Observable<FeatureFlags> {
        return this.getFeatureFlags.execute('featureFlags');
    }
}
